export const formatMessageContent = (formData) => {
  const { name, email, message } = formData;

  const subject = `New Contact via BlueCherry.io: ${name || 'No Name Provided'}`.trim();

  const textContentArray = [];
  const htmlContentArray = [];

  const addField = (label, value) => {
    if (value !== undefined && value !== null && value !== '') {
      textContentArray.push(`${label}: ${value}`);

      if (label === 'Message') {
        const formattedMessage = String(value).replace(/\n/g, '<br>');
        htmlContentArray.push(`<p><strong>${label}:</strong><br>${formattedMessage}</p>`);
      } else {
        htmlContentArray.push(`<p><strong>${label}:</strong> ${value}</p>`);
      }
    }
  };

  addField('Name', name);
  addField('Email', email);
  addField('Message', message);

  const textContent = textContentArray.join('\n');
  const htmlContent = `
    <h2>New Contact via BlueCherry.io:</h2>
    ${htmlContentArray.join('')}
  `.trim();

  return { subject, textContent, htmlContent };
};

export const formatEmailContent = (formData) => {
  const {
    company_name = '',
    contact_person = '',
    project_type = '',
    reason_for_switching = '',
  } = formData;

  const subject = `New Project via BlueCherry.io | ${company_name} - ${contact_person}`.trim();

  const htmlSection = (title, fields) => {
    const filtered = fields.filter(([_, value]) => value !== undefined && value !== null && value !== '');
    if (!filtered.length) return '';
    const body = filtered.map(([label, value]) => `<p><strong>${label}:</strong> ${value}</p>`).join('');
    return `<h3>${title}</h3>${body}`;
  };

  const textSection = (title, fields) => {
    const filtered = fields.filter(([_, value]) => value !== undefined && value !== null && value !== '');
    if (!filtered.length) return '';
    const body = filtered.map(([label, value]) => `${label}: ${value}`).join('\n');
    return `\n${title}\n${'-'.repeat(title.length)}\n${body}`;
  };

  const htmlSections = [];
  const textSections = [];

  // Partner info (if present)
  htmlSections.push(htmlSection("Partner Info", [
    ["Selected Partner", formData.select_partner],
  ]));
  textSections.push(textSection("Partner Info", [
    ["Selected Partner", formData.select_partner],
  ]));

  // Company Info
  htmlSections.push(htmlSection("Company Information", [
    ["Company Name", formData.company_name],
    ["Company Website", formData.company_website],
    ["Contact Person", formData.contact_person],
    ["Email", formData.email],
    ["Phone", formData.phone],
  ]));
  textSections.push(textSection("Company Information", [
    ["Company Name", formData.company_name],
    ["Company Website", formData.company_website],
    ["Contact Person", formData.contact_person],
    ["Email", formData.email],
    ["Phone", formData.phone],
  ]));

  // Budget / Resources
  htmlSections.push(htmlSection("Budget & Resources", [
    ["Budget", formData.budget],
    ["Resources", formData.resources],
  ]));
  textSections.push(textSection("Budget & Resources", [
    ["Budget", formData.budget],
    ["Resources", formData.resources],
  ]));

  // Project Type
  htmlSections.push(htmlSection("Project Type", [
    ["Project Type", formData.project_type],
  ]));
  textSections.push(textSection("Project Type", [
    ["Project Type", formData.project_type],
  ]));

  // Project Info - vary by type
  if (project_type === "Existing, without sensors") {
    htmlSections.push(htmlSection("Project Information", [
      ["Project Name", formData.project_name],
      ["Quantity", formData.quantity],
      ["Market Potential", formData.market_potential],
      ["Project Description", formData.project_description],
    ]));
    textSections.push(textSection("Project Information", [
      ["Project Name", formData.project_name],
      ["Quantity", formData.quantity],
      ["Market Potential", formData.market_potential],
      ["Project Description", formData.project_description],
    ]));
  } else if (project_type === "Existing, with computer") {
    htmlSections.push(htmlSection("Project Information", [
      ["Install Software", formData.install_software],
      ["Operating System", formData.operating_system],
      ["Project Description", formData.project_description],
    ]));
    textSections.push(textSection("Project Information", [
      ["Install Software", formData.install_software],
      ["Operating System", formData.operating_system],
      ["Project Description", formData.project_description],
    ]));
  } else if (project_type === "Design phase") {
    htmlSections.push(htmlSection("Project Information", [
      ["Project Description", formData.project_description],
      ["Project Objectives", formData.project_objectives],
      ["Market Potential", formData.market_potential],
    ]));
    textSections.push(textSection("Project Information", [
      ["Project Description", formData.project_description],
      ["Project Objectives", formData.project_objectives],
      ["Market Potential", formData.market_potential],
    ]));
  } else if (project_type === "Switching platform") {
    const isOther = reason_for_switching === "other";
    htmlSections.push(htmlSection("Switching Platform", [
      ["Current Platform", formData.current_platform],
      ["Reason for Switching", reason_for_switching],
      ...(isOther ? [["Other Reason", formData.other_reason]] : []),
    ]));
    textSections.push(textSection("Switching Platform", [
      ["Current Platform", formData.current_platform],
      ["Reason for Switching", reason_for_switching],
      ...(isOther ? [["Other Reason", formData.other_reason]] : []),
    ]));
  }

  const htmlContent = `<h2>New Project via BlueCherry.io</h2>${htmlSections.join('')}`.trim();
  const textContent = textSections.join('\n').trim();

  return { subject, textContent, htmlContent };
};

